import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  AppealReplyRequest,
  UserAppealsRequest,
  AppealTopicsRequest,
  UserAppealResponse,
  AppealTopicResponse,
  AppealFileDeleteRequest,
  AppealRepliesRequest,
  AppealReplyResponse,
  AppealStatusUpdateRequest,
} from "../types/api/appeals";

const path = `/feedback/admin/${process.env.REACT_APP_API_VERSION}/appeals`;

// Обращения пользователей - Получить список
export function fetchUserAppealsList(params: UserAppealsRequest) {
  return mainAPI.get<UserAppealResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Обращение пользователя - Ответить
export function replyToUserAppeal(appealId: string, data: AppealReplyRequest) {
  return mainAPI.post(`${path}/${appealId}/reply`, data).then(
    (res) => {
      return Promise.resolve(res.data as UserAppealResponse);
    },
    (error) =>
      handleApiError(
        error,
        "Что-то пошло не так. Попробуйте ответить на обращение пользователя еще раз"
      )
  );
}

// Темы обращений - Получить список
export function fetchAppealTopics(params: AppealTopicsRequest) {
  return mainAPI.get<AppealTopicResponse[]>(`${path}/topics`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Обращение пользователя - Удалить медиа
export function deleteAppealFile(
  appealId: string,
  data: AppealFileDeleteRequest
) {
  return mainAPI
    .post(`${path}/${appealId}/media/delete`, { ids: data.ids })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error)
    );
}

// Обращение пользователя - Получить ответы
export function fetchAppealReplies(
  appealId: string,
  params: AppealRepliesRequest
) {
  return mainAPI
    .get<AppealReplyResponse[]>(`${path}/${appealId}/replies`, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Произошла ошибка")
        );
      }
    );
}

// Обращения пользователей - Изменить статус
export function updateAppealStatus(data: AppealStatusUpdateRequest) {
  return mainAPI.post(`${path}/status`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
